import React, { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import axios from "axios";

const GoogleCallback: React.FC = () => {
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const code = params.get("code");
    const error = params.get("error");

    const exchangeCode = async () => {
      try {
        await axios.post("/integrations/google/calendar/callback", { code });
        navigate("/settings", { replace: true });
      } catch (e) {
        navigate("/settings", { replace: true });
      }
    };

    if (error) {
      navigate("/settings", { replace: true });
      return;
    }

    if (code) {
      exchangeCode();
    } else {
      navigate("/settings", { replace: true });
    }
  }, [location.search, navigate]);

  return null;
};

export default GoogleCallback; 